module.exports = __webpack_public_path__ + "img/why-icon.50b4ac7a.svg";